import { render, staticRenderFns } from "./ExpiredStudio.vue?vue&type=template&id=07232d49&scoped=true&"
import script from "./ExpiredStudio.vue?vue&type=script&lang=js&"
export * from "./ExpiredStudio.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredStudio.vue?vue&type=style&index=0&id=07232d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07232d49",
  null
  
)

export default component.exports